import { fromJS, List, Map } from 'immutable';
import ActivityEntry from '../../utils/models/ActivityEntry';
import {
	ACTIVITY_CHANGED,
	COMMENT_RECEIVED,
	SET_ACTIVITY_LOADING,
	WS_DATA_DEVICE_COMMENT,
	WS_DATA_GEOFENCE_COMMENT
} from '../constants/activity.constants';
import { AUTH_SUCCESS } from '../../containers/LoginPage/constants';

// State is keyed by entity+id: { 'device:12': { entries: List<ActivityEntry>, fetched, loading } }.
// Ids are only unique per entity, so the key has to carry both.
export const activityKey = (entity, objectId) => `${entity}:${objectId}`;

export const initialState = fromJS({
	byObject: {}
});

const emptyObjectState = Map({ entries: List(), fetched: false, loading: false });

function prependEntry(state, entry) {
	// The entry names its own subject, so a comment pushed over the websocket lands on its feed.
	const key = activityKey(entry.type, entry.objectId);
	const objectState = state.getIn(['byObject', key]) || emptyObjectState;
	const entries = objectState.get('entries');
	// The poster receives both the POST response and the WS echo — de-dupe by id.
	if (entries.some(e => e.id === entry.id)) return state;
	return state.setIn(['byObject', key], objectState.set('entries', entries.unshift(entry)));
}

export default function activityReducer(state: Map = initialState, action) {
	switch (action.type) {
		case AUTH_SUCCESS:
			return initialState;
		case ACTIVITY_CHANGED:
			return state.setIn(['byObject', activityKey(action.entity, action.objectId)], Map({
				entries: List(action.entries),
				fetched: true,
				loading: false
			}));
		case SET_ACTIVITY_LOADING: {
			const key = activityKey(action.entity, action.objectId);
			const objectState = state.getIn(['byObject', key]) || emptyObjectState;
			return state.setIn(['byObject', key], objectState.set('loading', action.loading));
		}
		case COMMENT_RECEIVED:
			return prependEntry(state, action.entry);
		case WS_DATA_DEVICE_COMMENT:
		case WS_DATA_GEOFENCE_COMMENT:
			return prependEntry(state, new ActivityEntry(action.data));
		default:
			return state;
	}
}
